! function () {
    "use strict";

    function e(t, i, n) {
        for (var a in i) "function" == typeof i[a] ? t.addEventListener(n + a, i[a]) : Object(i[a]) === i[a] ? e(t, i[a], n + a + "-") : t.setAttribute(n + a, i[a])
    }

    function t(t) {
        var i = t instanceof Node ? t : document.createElement(t);
        return [].slice.call(arguments, 1).forEach(function (t) {
            t instanceof Node ? i.appendChild(t) : "string" == typeof t ? i.appendChild(document.createTextNode(t)) : e(i, t, "")
        }), i
    }

    function i(e, t, i) {
        var n = document.createEvent("CustomEvent");
        n.initCustomEvent(t, !0, !0, i), e.dispatchEvent(n)
    }

    function n(e) {
        var t = void 0,
            i = [];
        e.addEventListener("blur", function () {
            i.forEach(function (e) {
                e.removeAttribute("js-focus"), e.removeAttribute("js-focus-ring")
            })
        }, !0), e.addEventListener("focus", function () {
            var e = document.activeElement;
            e instanceof Element && (e.setAttribute("js-focus", ""), t && e.setAttribute("js-focus-ring", ""), i.push(e))
        }, !0), e.addEventListener("keydown", function () {
            t = clearTimeout(t) || setTimeout(function () {
                t = 0
            }, 100)
        }, !0)
    }
    var a = function () {
        Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function (e) {
            var t = this,
                i = this;
            if (!document.documentElement.contains(t)) return null;
            do {
                if (i.matches(e)) return i;
                i = i.parentElement
            } while (null !== i);
            return null
        }), document.addEventListener("click", function (e) {
            var t = e.target.closest("a, [data-onclick-for]");
            if (t) {
                var i = t.ownerDocument.getElementById(t.getAttribute("data-onclick-for"));
                i && i.click()
            }
        })
    },
        r = function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        },
        s = function () {
            function e(e, t) {
                for (var i = 0; i < t.length; i++) {
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
                }
            }
            return function (t, i, n) {
                return i && e(t.prototype, i), n && e(t, n), t
            }
        }(),
        o = function () {
            function e(t, i) {
                function n() {
                    clearTimeout(h), h = setTimeout(u, 0, event)
                }
                var a = this;
                r(this, e);
                var s = Object(i);
                for (var o in e.defaults) this[o] = o in s ? s[o] : e.defaults[o];
                var l = this.target = t instanceof Element ? t : document.querySelector(t);
                l.classList.add(this.prefix), l.id = l.id || this.prefix;
                var c = function (e, t) {
                    var i = a[e + "Control"] = document.createElement("button");
                    i.className = a.prefix + "-immediate-control " + a.prefix + "-" + e + "-control", i.addEventListener("click", function () {
                        a.setSlideByIndex(a.currentIndex + t)
                    }), i.appendChild(document.createElement("span")).appendChild(document.createTextNode(a.lang[e] + " " + a.lang.slide))
                };
                c("previous", -1), c("next", 1), l.insertBefore(this.previousControl, l.firstElementChild), l.appendChild(this.nextControl);
                var d = this.paginationControls = document.createElement("nav");
                d.className = this.prefix + "-pagination-controls", d.setAttribute("role", "navigation"), d.setAttribute("aria-labelledby", l.id), l.appendChild(d), this.paginationControl = [], this.slides = [].map.call(Object(this.slides) === this.slides && "number" == typeof this.slides.length ? this.slides : l.querySelectorAll(this.slides), function (e, t) {
                    e.id = e.id || a.prefix + "-slide-" + t, e.classList.add(a.prefix + "-slide"), e.classList.add(a.prefix + "-slide-" + t), e.classList.add(a.prefix + "-inactive-slide"), e.setAttribute("aria-hidden", !0);
                    var i = a.paginationControl[t] = d.appendChild(document.createElement("button"));
                    return i.className = a.prefix + "-pagination-control " + a.prefix + "-inactive-control", i.addEventListener("click", function () {
                        a.setSlideByIndex(t)
                    }), i.appendChild(document.createElement("span")).appendChild(document.createTextNode(a.lang.slide + " " + (t + 1))), {
                            target: e,
                            control: i
                        }
                }), this.isVisible = !0, this.isMouseInteractive = !1, this.isFocusInteractive = !1, this.isInputInteractive = !1;
                var u = function (e) {
                    var t = "visibilitychange" === e.type ? "visible" === l.ownerDocument.visibilityState : a.isVisible,
                        i = "mouseenter" === e.type || "mouseleave" !== e.type && a.isMouseInteractive,
                        n = "focusin" === e.type || "focusout" !== e.type && a.isFocusInteractive,
                        r = i || n;
                    t !== a.isVisible && (a.isVisible = t, a.autoplay && a[t ? "play" : "pause"](), a.dispatch(t ? "visibilityvisible" : "visibilityhidden", e.target), a.dispatch("visibilitychange", e.target)), i !== a.isMouseInteractive && (a.isMouseInteractive = i, a.dispatch(i ? "mouseenter" : "mouseleave", e.target), a.dispatch("mousechange", e.target)), n !== a.isFocusInteractive && (a.isFocusInteractive = n, a.autoplay && a[n ? "pause" : "play"](), a.dispatch(n ? "focusenter" : "focusleave", e.target), a.dispatch("focuschange", e.target)), r !== a.isInputInteractive && (a.isInputInteractive = r, a.dispatch(r ? "inputenter" : "inputleave", e.target), a.dispatch("inputchange", e.target))
                };
                l.ownerDocument.addEventListener("visibilitychange", u), l.addEventListener("mouseenter", u), l.addEventListener("mouseleave", u), l.addEventListener("focusout", n), l.addEventListener("focusin", n);
                var h = void 0,
                    m = this.currentIndex || 0;
                this.currentIndex = null, this.setSlideByIndex(m), this.dispatch("loaded", l), this.autoplay && this.play()
            }
            return s(e, [{
                key: "setSlideByIndex",
                value: function (e) {
                    if (this.currentIndex !== e) {
                        var t = this.slides.length,
                            i = this.lastIndex = this.currentIndex,
                            n = this.currentIndex = (t + e % t) % t,
                            a = this.slides[i],
                            r = this.slides[n];
                        a && (a.target.classList.remove(this.prefix + "-active-slide"), a.target.classList.add(this.prefix + "-inactive-slide"), a.target.setAttribute("aria-hidden", !0), a.control.classList.remove(this.prefix + "-active-control"), a.control.classList.add(this.prefix + "-inactive-control"), a.control.removeAttribute("aria-current"), a.control.removeAttribute("aria-controls"), this.dispatch("slideleave", a.target)), r.target.classList.add(this.prefix + "-active-slide"), r.target.classList.remove(this.prefix + "-inactive-slide"), r.target.removeAttribute("aria-hidden"), r.control.classList.add(this.prefix + "-active-control"), r.control.classList.remove(this.prefix + "-inactive-control"), r.control.setAttribute("aria-current", !0), r.control.setAttribute("aria-controls", r.target.id), this.dispatch("slideenter", r.target), this.dispatch("slidechange", r.target)
                    }
                }
            }, {
                key: "dispatch",
                value: function (e, t) {
                    var i = document.createEvent("CustomEvent");
                    i.initCustomEvent(this.prefix + ":" + e, !0, !1, this), t.dispatchEvent(i)
                }
            }, {
                key: "play",
                value: function () {
                    var e = this;
                    this._interval || (! function t() {
                        var i = e.slides[e.currentIndex].duration || e.duration;
                        e._interval = setTimeout(function () {
                            e.setSlideByIndex(e.currentIndex + 1), e._interval && (e._interval = clearTimeout(e._interval), t())
                        }, i)
                    }(), this.dispatch("play", this.target), this.dispatch("playpause", this.target))
                }
            }, {
                key: "pause",
                value: function () {
                    this._interval && (this._interval = clearTimeout(this._interval), this.dispatch("pause", this.target), this.dispatch("playpause", this.target))
                }
            }]), e
        }();
    o.defaults = {
        prefix: "carousel",
        slides: "li",
        currentIndex: 0,
        duration: 8e3,
        autoplay: !1,
        lang: {
            next: "Next",
            previous: "Previous",
            slide: "Slide"
        }
    };
    var l = function () {
        [].forEach.call(document.querySelectorAll(".n-gallery"), function (e) {
            new o(e, {
                prefix: "n-gallery"
            })
        })
    },
        c = [.47, 0, .745, .715],
        d = 400,
        u = function (e) {
            return ! function t() {
                /m/.test(document.readyState) ? (document.removeEventListener("readystatechange", t), e()) : document.addEventListener("readystatechange", t)
            }()
        },
        h = function () {
            [].forEach.call(document.querySelectorAll(".n-gateway-carousel"), function (e) {
                function t(t) {
                    var i = t.detail,
                        n = i.slides[i.currentIndex],
                        a = n.target.getAttribute("data-theme"),
                        r = n.target.getAttribute("data-image-url");
                    e.setAttribute("data-theme", a), e.style.backgroundImage = "url(" + r + ")", u(function () { }), n.target.animate({
                        opacity: [0, 1],
                        transform: ["translate(0,50px)", "translate(0,0)"]
                    }, {
                            duration: d,
                            easing: "cubic-bezier(" + c + ")"
                        })
                }
                e.addEventListener("n-gateway-carousel:loaded", function (e) {
                    var t = e.detail;
                    t.paginationControls.setAttribute("data-items", t.slides.length), t.slides.forEach(function (e) {
                        var t = e.target.getAttribute("data-thumbnail-url");
                        e.control.style.backgroundImage = "url(" + t + ")"
                    })
                }), e.addEventListener("n-gateway-carousel:loaded", t), e.addEventListener("n-gateway-carousel:slideenter", t), new o(e, {
                    prefix: "n-gateway-carousel",
                    slides: ".n-gateway-carousel-article",
                    duration: 5e3
                })
            })
        },
        m = function (e) {
            function n(n) {
                var isArcGis = location.pathname.indexOf('arcgis-blog') > -1 ? true : false;
                if (isArcGis) {
                    return;
                }

                n && "reset" === n.type && (s.value = "");
                var a = s.value;
                a !== m && (m = a, i(u, e.prefix + ":input", {
                    value: m,
                    event: n
                })), h && !a ? (h = !1, r.removeAttribute("data-filled"), d.removeAttribute("data-filled")) : !h && a && (h = !0, t(r, {
                    data: {
                        filled: ""
                    }
                }), t(d, {
                    data: {
                        filled: ""
                    }
                })), o.nodeValue = a;
                var p = l.scrollWidth + "px";
                c.style.width = p
            }

            function a(t) {
                i(u, e.prefix + ":submit", {
                    value: s.value,
                    event: t
                })
            }
            var r = t("label", {
                class: e.prefix + "-label",
                for: e.prefix + "-query-control"
            }, e.queryLabel),
                s = t("input", {
                    class: e.prefix + "-control",
                    id: e.prefix + "-control",
                    type: "search",
                    name: "q",
                    autocapitalize: "off",
                    autocomplete: "off",
                    autocorrect: "off",
                    spellcheck: "false"
                }),
                o = document.createTextNode(""),
                l = t("div", {
                    class: e.prefix + "-measure-text",
                    aria: {
                        hidden: !0
                    }
                }, o),
                c = t("div", {
                    class: e.prefix + "-measure"
                }, l),
                d = t("button", {
                    class: e.prefix + "-submit",
                    type: "submit",
                    aria: {
                        label: e.submitLabel
                    }
                }),
                u = t("form", {
                    class: e.prefix + "-form",
                    action: e.action,
                    role: "search",
                    aria: {
                        label: e.label
                    }
                }, r, s, c, d);
            u.addEventListener(e.prefix + ":focus", function () {
                s.focus()
            });
            var h = !1,
                m = "";
            return u.addEventListener("DOMNodeInserted", function t() {
                u.parentNode && (u.removeEventListener("DOMNodeInserted", t), i(u, e.prefix + ":update", e))
            }), u.addEventListener(e.prefix + ":update", function () {
                u.ownerDocument.defaultView.matchMedia(e.matchMedia || "(max-width: 720px)").addListener(n), s.addEventListener("input", n), u.addEventListener("reset", n), u.addEventListener("submit", a), u.addEventListener(e.prefix + ":unload", onunload)
            }), u
        },
        p = function () {
            [].forEach.call(document.querySelectorAll(".n-gateway-search"), function (e) {
                var t = m({
                    prefix: "n-gateway-search",
                    action: e.getAttribute("data-action"),
                    label: "Esri Blog",
                    submitLabel: "Search",
                    cancelLabel: "Cancel",
                    queryLabel: "Search"
                });

                if (window && window.isMultisite) {
                    t.querySelector("input").name = "search", e.appendChild(t), n(e)
                } else {
                    t.querySelector("input").name = "s", e.appendChild(t), n(e)
                }
                
            })
        },
        f = function () {
            function e(t, i) {
                var n = this;
                r(this, e), this.target = t;
                var a = this.opts = {};
                for (var s in e.defaults) a[s] = i && s in i ? i[s] : e.defaults[s];
                this.menu = {
                    link: t.querySelector(a.menuControlSelector),
                    menu: t.querySelector(a.submenuSelector),
                    list: t.querySelector(a.sublistSelector),
                    parent: t.querySelector(a.menuSelector),
                    target: t
                }, this.menu.isExpanded = "true" === this.menu.link.getAttribute("aria-expanded"), this.menu.menu.id = this.menu.menu.id || "snav-" + ++e.uuid, this.menu.link.setAttribute("aria-controls", this.menu.menu.id), this.menu.link.setAttribute("aria-expanded", this.menu.isExpanded), this.menu.isExpanded ? t.setAttribute("data-expanded", "") : t.removeAttribute("data-expanded"), this.menus = [this.menu].concat(Array.prototype.slice.call(t.querySelectorAll(a.menusSelector)).map(function (t) {
                    var i = t.parentNode.querySelector(a.sublinkSelector),
                        n = "true" === i.getAttribute("aria-expanded");
                    return t.id = t.id || "snav-" + ++e.uuid, i.setAttribute("aria-controls", t.id), i.setAttribute("aria-expanded", n), t.setAttribute("aria-hidden", !n), {
                        isExpanded: n,
                        link: i,
                        menu: t
                    }
                })), this.more = t.querySelector(a.moreSelector), this.isSmall = window.matchMedia("(max-width: 615px)"), this.isSmallOrMedium = window.matchMedia("(max-width: 975px)"), this.isSmall.addListener(function () {
                    return n.onmediachange()
                }), this.onmediachange(), this.menus.forEach(function (e) {
                    window.addEventListener("click", function (t) {
                        e.link.contains(t.target) ? (t.preventDefault(), n.toggleMenu(e)) : n.isSmallOrMedium.matches && !n.target.contains(t.target) ? n.toggleMenu(e, !1) : n.isSmallOrMedium.matches || e.menu.contains(t.target) || n.toggleMenu(e, !1)
                    }), window.addEventListener("keydown", function (t) {
                        27 === t.keyCode && n.toggleMenu(e, !1)
                    })
                });
                var o = document.getElementById("globalnav"),
                    l = null !== o ? o.offsetHeight : 56;
                this.targetScrollY = t.getBoundingClientRect().top + window.pageYOffset || l, this.isFixed = !1, window.addEventListener("scroll", function () {
                    n.onscroll()
                }), this.onscroll()
            }
            return s(e, [{
                key: "toggleMenu",
                value: function (e, t) {
                    var i = void 0 === t ? !e.isExpanded : t;
                    i !== e.isExpanded && (e.isExpanded = i, e.link.setAttribute("aria-expanded", i), e.menu.setAttribute("aria-hidden", !i), e.target && (i ? e.target.setAttribute("data-expanded", "") : e.target.removeAttribute("data-expanded")))
                }
            }, {
                key: "onmediachange",
                value: function () {
                    this.menu.menu.setAttribute("aria-hidden", this.isSmallOrMedium.matches && !this.menu.isExpanded), this.isSmall.matches ? (this.menu.menu.insertBefore(this.more, this.menu.list.nextSibling), this.menu.menu.setAttribute("role", "navigation"), this.menu.list.setAttribute("role", "navigation")) : (this.target.appendChild(this.more), this.menu.menu.setAttribute("role", "group"), this.menu.list.removeAttribute("role"))
                }
            }, {
                key: "onscroll",
                value: function () {
                    var e = window.pageYOffset >= this.targetScrollY;
                    e !== this.isFixed && (this.isFixed = e, e ? this.target.setAttribute("data-fixed", "") : this.target.removeAttribute("data-fixed"))
                }
            }]), e
        }();
    f.uuid = 0, f.defaults = {
        menuSelector: ".c-snav-menu",
        menuControlSelector: ".c-snav-menu-title",
        submenuSelector: ".c-snav-submenu",
        sublistSelector: ".c-snav-sublist",
        moreSelector: ".c-snav-more",
        menusSelector: ".c-snav-termenu",
        sublinkSelector: ".c-snav-sublink"
    };
    var v = function () {
        var e = document.querySelector(".c-snav");
        e && new f(e)
    },
        g = function () {
            [].forEach.call(document.querySelectorAll(".n-subscribe-action"), function (e, t) {
                function i(t) {
                    e.setAttribute("aria-expanded", t), n.setAttribute("aria-hidden", !t), t && !n.src && (n.src = "//go.pardot.com/l/82202/2017-04-25/d4tgkd")
                }
                var n = e.parentNode.querySelector(".n-subscribe-action ~ .n-subscribe-iframe");
                if (n) {
                    var a = e.id = e.id || "n-subscribe-action--" + t,
                        r = n.id = n.id || "n-subscribe-iframe--" + t,
                        s = "true" === e.getAttribute("aria-expanded");
                    e.setAttribute("aria-controls", r), e.setAttribute("aria-expanded", s), n.setAttribute("aria-labelledby", a), e.addEventListener("click", function () {
                        i(s = !s)
                    }), i(s)
                }
            })
        },
        b = function () {
            function e(e) {
                var t = screen.width / 2 - 250,
                    i = screen.height / 2 - 150;
                window.open(e, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=500,height=300,top=" + i + ",left=" + t + ")")
            }
            Array.prototype.slice.call(document.querySelectorAll("[data-sharing]")).forEach(function (t) {
                t.addEventListener("click", function (event) {
                    event.preventDefault(), e(t.getAttribute("data-sharing"))
                })
            })
        },
        y = function () {
            var e = function (e) {
                function t() {
                    d.call(e, u + m, t);
                    var s = {
                        boxSizing: "content-box",
                        display: "inline-block",
                        overflow: "hidden"
                    };
                    "backgroundColor backgroundImage borderColor borderStyle borderWidth bottom fontSize lineHeight height left opacity margin position right top visibility width".replace(/\w+/g, function (e) {
                        s[e] = l[e]
                    }), o.border = o.margin = o.padding = 0, o.display = "block", o.height = o.width = "auto", o.opacity = 1;
                    var c = e.videoWidth || e.width,
                        p = e.videoHeight || e.height,
                        f = c / p,
                        v = document.createElement("object-fit");
                    v.appendChild(e.parentNode.replaceChild(v, e));
                    for (var g in s) v.runtimeStyle[g] = s[g];
                    var b;
                    "fill" === i ? h ? (o.width = n, o.height = a) : (o["-ms-transform-origin"] = "0% 0%", o["-ms-transform"] = "scale(" + n / c + "," + a / p + ")") : (f < r ? "contain" === i : "cover" === i) ? (b = a * f, o.width = Math.round(b) + "px", o.height = a + "px", o.marginLeft = Math.round((n - b) / 2) + "px") : (b = n / f, o.width = n + "px", o.height = Math.round(b) + "px", o.marginTop = Math.round((a - b) / 2) + "px")
                }
                var i = e.currentStyle ? e.currentStyle["object-fit"] : null;
                if (i && /^(contain|cover|fill)$/.test(i)) {
                    var n = e.clientWidth,
                        a = e.clientHeight,
                        r = n / a,
                        s = e.nodeName.toLowerCase(),
                        o = e.runtimeStyle,
                        l = e.currentStyle,
                        c = e.addEventListener || e.attachEvent,
                        d = e.removeEventListener || e.detachEvent,
                        u = e.addEventListener ? "" : "on",
                        h = "img" === s,
                        m = h ? "load" : "loadedmetadata";
                    c.call(e, u + m, t), e.complete && t()
                }
            };
            e.init = function () {
                if (document.body)
                    for (var t = document.querySelectorAll("img,video"), i = -1; t[++i];) e(t[i]);
                else setTimeout(e.init)
            }, /MSIE|Trident/.test(navigator.userAgent) && e.init()
        };
    ! function (e) {
        ! function t() {
            /c/.test(document.readyState) && document.body ? (document.removeEventListener("DOMContentLoaded", t), e()) : document.addEventListener("DOMContentLoaded", t)
        }()
    }(function () {
        v(), l(), h(), p(), g(), a(), b(), y()
    })
}();
//# sourceMappingURL=newsroom.js.map